var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-[32px]"},[_c('document-file-report'),_c('div',{staticClass:"my-[25px]"}),_c('document-file-manual')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }